import _ from 'lodash';

export const getBy = (obj, path, defaultValue = undefined) => {
  if (typeof path === 'string') path = _.toPath(path);

  for (const [i, el] of path.entries()) {
    if (typeof el === 'function') {
      path = path.slice(i + 1);

      return el(obj, o => getBy(o, path, defaultValue), 'get');
    }
    obj = obj[el];

    if (obj === undefined) return defaultValue;
  }

  return obj;
};

// TODO: Reconsider if obj passed to func should be cloned.
export const updateBy = (obj, path, func) => {
  if (typeof path === 'string') path = _.toPath(path);

  obj = _.clone(obj);

  if (path.length == 0) return func(obj);

  let last = obj;
  let lastAccessor;

  for (const [i, el] of path.entries()) {
    if (typeof el === 'function') {
      path = path.slice(i + 1);
      const continueFunc =

        subject => el(subject, o => updateBy(o, path, func), 'update');

      if (i == 0) return continueFunc(obj);

      last[lastAccessor] = continueFunc(last[lastAccessor]);
      return obj;
    }
    if (i > 0) last = last[lastAccessor];

    lastAccessor = el;
    last[lastAccessor] = _.clone(last[lastAccessor]);
  }

  last[lastAccessor] = func(last[lastAccessor]);
  return obj;
};

export const deleteBy = (obj, path) => {
  if (path.length == 0) return undefined;

  path = _.clone(path);

  const lastAccessor = path.pop();

  const func =
    typeof lastAccessor === 'function'
      ? o => lastAccessor(o, undefined, 'delete')
      : o => delete o[lastAccessor];

  return updateBy(obj, path, func);
};

// TODO: setBy for performance.

export const all = (array, f, type) => (type == 'delete' ? [] : array.map(f));
export const where = predicate => (array, f, type) => {
  switch (type) {
    case 'get':
      return array.filter(predicate).map(f);
    case 'update':
      return array.map(o => (predicate(o) ? f(o) : o));
    case 'delete':
      return array.filter(o => !predicate(o));
    default:

      throw 'unsupported access type';
  }
};

export default {
  deleteBy,
  getBy,
  updateBy,
  all,
  where,
};
